<template>
  <div class="shanda-bdweb-bg">
    <div class="shanda-bdweb">
      <!-- <div class="catg">
        <div class="link-pic">
          <img src="../../assets/images/semAd/line-pic.png" />
        </div>
      </div> -->
      <div class="catg">
        <Row align="middle">
          <Col span="12">
            <div class="bdweb-logo">
              <img src="../../assets/images/semAd/logo-sd.png" />
            </div>
          </Col>
          <Col span="12">
            <Row align="middle" justify="end">
              <Col span="10" class="top-nav">
                <Space wrap>
                  <Button type="text" class="active">首页</Button>
                  <Button type="text">联系我们</Button>
                </Space></Col
              >
              <Col class="zs-line" span="12">
                <Row class="zs-line-box" align="middle" justify="end">
                  <Col span="4">招商<br />热线</Col>
                  <Col flex="auto" class="line" span="20">021-38586888</Col>
                </Row>
              </Col>
            </Row>
            <div></div>
          </Col>
        </Row>
        <div class="banner-area">
          <img src="../../assets/images/semAd/banner-bg.jpg" />
        </div>
        <div class="shanda-part6">
          <Row class="part6-cont" :gutter="16">
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg1.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon1.png" />
                <h2>张江核心区域</h2>
                <div class="dec">张江名气比邻<br />高效科研院所集聚</div>
              </div>
            </Col>
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg2.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon2.png" />
                <h2>毗邻中环高架</h2>
                <div class="dec">
                  紧邻中环金科路口<br />30分钟可达浦东机场、度假区
                </div>
              </div>
            </Col>
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg3.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon3.png" />
                <h2>紧邻13号线中科路站</h2>
                <div class="dec">距离地铁站700米，<br />步行可达</div>
              </div>
            </Col>
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg4.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon4.png" />
                <h2>商业配套齐全</h2>
                <div class="dec">
                  麦当劳、星巴克、奈雪的茶 <br />等品牌商户云集
                </div>
              </div>
            </Col>
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg5.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon5.png" />
                <h2>战略新兴产业</h2>
                <div class="dec">聚焦脑科学 <br />人工智能、数字经济产业</div>
              </div>
            </Col>
            <Col span="4" class="part6-list">
              <img class="bg-img" src="../../assets/images/semAd/hj-bg6.jpg" />
              <div class="list-cont">
                <img src="../../assets/images/semAd/part6-icon6.png" />
                <h2>房租补贴政策</h2>
                <div class="dec">入驻可享每年 <br />最高15万房租补贴</div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="mid-ad" @click="modal = true">
          <img src="../../assets/images/semAd/mid-ad.png" />
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">
          精装房源<small>多样空间户型风格满足客户多样化办公空间选择</small>
        </div>
        <div class="catg-cont">
          <div class="catg1-top">
            <Row>
              <Col span="12">
                <Row justify="center" align="middle">
                  <Col class="picB" flex="130px"
                    ><img src="../../assets/images/semAd/catg1-icon1.png"
                  /></Col>
                  <Col class="top-cont" flex="auto">
                    <h3>空间选择多样</h3>
                    <p>
                      <span>100㎡内</span>
                      <span>100~300㎡</span>
                      <span>300~1000㎡</span>
                      <span>1000㎡以上</span>
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span="12">
                <Row justify="center" align="middle">
                  <Col class="picB" flex="130px"
                    ><img src="../../assets/images/semAd/catg1-icon2.png"
                  /></Col>
                  <Col class="top-cont" flex="auto">
                    <h3>空间选择多样</h3>
                    <p>为客户提供房源选择、定制装修、入驻孵化等一站式服务</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div class="catg1-botm">
            <Row :gutter="15">
              <Col span="9">
                <img src="../../assets/images/semAd/jz-pic1.png" />
              </Col>
              <Col span="5">
                <div><img src="../../assets/images/semAd/jz-pic2.png" /></div>
                <div class="botm-cont">
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">办公家具精装全配</Col>
                  </Row>
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">隔断到顶私密性好</Col>
                  </Row>
                </div>
              </Col>
              <Col span="5">
                <div><img src="../../assets/images/semAd/jz-pic3.png" /></div>
                <div class="botm-cont">
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">企业LOGO展示墙</Col>
                  </Row>
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">裸顶白墙视野开阔</Col>
                  </Row>
                </div>
              </Col>
              <Col span="5">
                <div><img src="../../assets/images/semAd/jz-pic4.png" /></div>
                <div class="botm-cont">
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">房型方正采光极佳</Col>
                  </Row>
                  <Row>
                    <Col class="ico" flex="20px"
                      ><img src="../../assets/images/semAd/icon-right.png"
                    /></Col>
                    <Col class="ico" flex="auto">可享15万房租补贴</Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">园区实景</div>
        <div class="catg-cont">
          <div class="catg2">
            <Row :gutter="16">
              <Col span="12">
                <div class="catg2-left">
                  <div class="left-pic">
                    <img src="../../assets/images/semAd/yq-pic1.png" />
                  </div>
                  <div class="left-msg">
                    <h2>盛大天地源创谷</h2>
                    <Row :gutter="16">
                      <Col span="6">
                        <div class="msg-box">
                          <img src="../../assets/images/semAd/ycg-ico1.png" />
                          <p>总建筑面积</p>
                          <h4>15万平方米</h4>
                        </div>
                      </Col>
                      <Col span="6">
                        <div class="msg-box">
                          <img src="../../assets/images/semAd/ycg-ico2.png" />
                          <p>科研办公</p>
                          <h4>8栋</h4>
                        </div>
                      </Col>
                      <Col span="6">
                        <div class="msg-box">
                          <img src="../../assets/images/semAd/ycg-ico3.png" />
                          <p>套内建筑面积</p>
                          <h4>100-200平方米</h4>
                        </div>
                      </Col>
                      <Col span="6">
                        <div class="msg-box">
                          <img src="../../assets/images/semAd/ycg-ico4.png" />
                          <p>物业服务</p>
                          <h4>自由物业</h4>
                        </div>
                      </Col>
                    </Row>
                    <div class="left-botm">
                      <span>创新生态之城</span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span="12">
                <div class="catg2-right">
                  <Row :gutter="16" class="catg-right-box">
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic2.png" />
                        <div class="bt-box">
                          <h4>会议中心</h4>
                          <p>可容纳20-200人的多功能会议室</p>
                        </div>
                      </div>
                    </Col>
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic3.png" />
                        <div class="bt-box">
                          <h4>青春里公寓</h4>
                          <p>2000余套品牌家居、拎包入住的高端人才公寓</p>
                        </div>
                      </div>
                    </Col>
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic6.png" />
                        <div class="bt-box">
                          <h4>智选餐厅</h4>
                          <p>为园区企业提供多元化餐饮需求</p>
                        </div>
                      </div>
                    </Col>
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic4.png" />
                        <div class="bt-box">
                          <h4>健身中心</h4>
                          <p>在工作之余，可以尽情享受健康生活</p>
                        </div>
                      </div>
                    </Col>
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic5.png" />
                        <div class="bt-box">
                          <h4>足球场</h4>
                          <p>一年一度的张江青年运动会，和您一期一会</p>
                        </div>
                      </div>
                    </Col>
                    <Col span="8">
                      <div class="msg-box">
                        <img src="../../assets/images/semAd/yq-pic7.png" />
                        <div class="bt-box">
                          <h4>包厢宴请</h4>
                          <p>为您提供一站式商务包厢宴请服务</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">商业配套齐全 品牌商户云集</div>
        <div class="catg-cont">
          <div class="catg3">
            <Row :gutter="16">
              <Col span="8">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic1.png" />
                  <div class="tit">星巴克</div>
                </div>
              </Col>
              <Col span="8">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic2.png" />
                  <div class="tit">奈雪</div>
                </div>
              </Col>
              <Col span="8">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic3.png" />
                  <div class="tit">麦当劳</div>
                </div>
              </Col>
            </Row>
            <br />
            <Row :gutter="16">
              <Col span="6">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic4.png" />
                  <div class="tit">由心咖啡</div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic5.png" />
                  <div class="tit">瑞幸</div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic6.png" />
                  <div class="tit">柠季</div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg3-box">
                  <img src="../../assets/images/semAd/sy-pic7.png" />
                  <div class="tit">立方米咖啡</div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">园区产业发展规划</div>
        <div class="catg-cont">
          <div class="catg4">
            <img src="../../assets/images/semAd/brain-pic.png" />
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">为什么选择盛大天地·源创谷?</div>
        <div class="catg-cont">
          <div class="catg4">
            <Row :gutter="16">
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico1.png" />
                  <h3>办公家具精装全配</h3>
                  <div class="txt-s">
                    可以为客户提供定制装修服务<br />满足客户多元化办公需求
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico2.png" />
                  <h3>企业服务周到</h3>
                  <div class="txt-s">
                    为科创企业提供全生命周期企业发展<br />服务体系助力企业创新发展
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico3.png" />
                  <h3>商业配套齐全</h3>
                  <div class="txt-s">
                    麦当劳、星巴克、奈雪的茶、柠季、<br />足球场、会议中心、青春里公寓等商业<br />配套齐全
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico4.png" />
                  <h3>位于张江核心区</h3>
                  <div class="txt-s">
                    位于张江科学城周边，名企比邻，复<br />旦大学张江校区、李政道研究所、上<br />海科技大学、上飞院等科研院所集聚
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico5.png" />
                  <h3>房租补贴政策</h3>
                  <div class="txt-s">
                    企业入驻孵化后<br />
                    可享受每年最高15万房租补贴
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico6.png" />
                  <h3>多元化青年社区</h3>
                  <div class="txt-s">
                    园区定期举办张江青运会、夏日集<br />市、科创沙龙等青年交流活动
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico7.png" />
                  <h3>产城融合宜居</h3>
                  <div class="txt-s">
                    园区配有TCA国际幼儿园、青春里公<br />寓、健身中心、推拿馆等打造宜商宜居<br />的社区化科创园区
                  </div>
                </div>
              </Col>
              <Col span="6">
                <div class="catg4-box">
                  <img src="../../assets/images/semAd/why-ico8.png" />
                  <h3>科创产业集聚</h3>
                  <div class="txt-s">
                    围绕脑科学、人工智能、数<br />字经济等战略新兴产业
                  </div>
                </div>
              </Col>
            </Row>
            <div class="catg4-zx">
              <Row align="middle" class="zx-box">
                <Col span="6" class="zx-box-L"
                  >今日已有 <span>124</span> 位业主<br />咨询预定现场看房</Col
                >
                <Col span="18" class="zx-box-R">
                  <Row :gutter="16" wrap class="zx-box-RTxt">
                    <Col span="18">
                      <Row align="middle">
                        <Col span="12" class="rtxt">
                          · 程先生 ㎡ <span>150******19</span> 42秒前
                        </Col>
                        <Col span="12" class="rtxt">
                          · 程先生 ㎡ <span>150******19</span> 42秒前
                        </Col>
                        <Col span="12" class="rtxt">
                          · 程先生 ㎡ <span>150******19</span> 42秒前
                        </Col>
                        <Col span="12" class="rtxt">
                          · 程先生 ㎡ <span>150******19</span> 42秒前
                        </Col>
                      </Row>
                    </Col>
                    <Col span="6" class="zx-btn">
                      <Modal v-model="modal" title="立即咨询">
                        <Row style="padding: 30px">
                          <Col span="24">
                            <Space>
                              <span
                                style="
                                  display: inline-block;
                                  width: 100px;
                                  text-align: right;
                                "
                                >输入姓名：</span
                              >
                              <Input
                                v-model="name"
                                placeholder="输入姓名"
                                style="width: auto"
                              /> </Space
                          ></Col>
                          <Col span="24" style="margin-top: 20px"
                            ><Space>
                              <span
                                style="
                                  display: inline-block;
                                  width: 100px;
                                  text-align: right;
                                "
                                >输入手机号：</span
                              >
                              <Input
                                v-model="mobile"
                                placeholder="输入手机号"
                                style="width: auto"
                              >
                              </Input> </Space
                          ></Col>
                        </Row>
                        <div slot="footer">
                          <Button type="primary" @click="ok">提交</Button>
                          <Button
                            @click="modal = false"
                            style="margin-left: 8px"
                            >取消</Button
                          >
                        </div> </Modal
                      ><Button @click="modal = true">我也要咨询</Button></Col
                    >
                  </Row>
                </Col>
              </Row>
            </div>
            <div class="catg4-location">
              <img src="../../assets/images/semAd/garden-location.jpg" />
              <div class="loaction-txt">
                项目总建筑面积15万㎡，由8栋科研办公楼组成，套内建筑面积为100-2000㎡，配备有空调、照明、架空地板等，提供拎包入驻一站式服务，可满足人工智能、集成电路、数字经济、AI芯片、元宇宙、软件信息等企业研发办公需求。
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">
          交通通达<small
            >盛大天地·源创谷坐落于张江科学城核心区域，毗邻中环高架，可通达浦东机场、迪士尼度假区等。</small
          >
        </div>
        <div class="catg-cont">
          <div class="catg5">
            <div class="intro-cont-box">
              <Row class="office-addr" align="middle">
                <Col span="18">
                  <!-- <div class="office-map">
                                            <img src="../../assets/images/web/office-map.jpg"/>
                                        </div> -->
                  <!-- 高德地图暂时不用 -->
                  <!-- <MapContainer
                    ref="mapContainer"
                    height="400px"
                    @loaded="hanldeMapLoaded"
                  >
                  </MapContainer> -->
                  <img :src="getDiTuUrl">
                </Col>
                <Col span="6">
                  <div class="addr-msg">
                    <ul>
                      <li>
                        <div class="iconL">
                          <!-- <Icon type="md-pin" /> -->
                          <img src="../../assets/images/semAd/icon-metro.jpg" />
                        </div>
                        <div class="msgR">
                          <!-- <p>地铁</p> -->
                          <div>
                            地铁：距13号线中科路地铁站900米（园区配有免费班车）
                          </div>
                        </div>
                      </li>
                      <li>
                        <div class="iconL">
                          <!-- <Icon type="md-bus" /> -->
                          <img src="../../assets/images/semAd/icon-bus.jpg" />
                        </div>
                        <div class="msgR">
                          <!-- <p>班车</p> -->
                          <div>公交：浦东25路、浦东70路、南川线、浦东25路</div>
                        </div>
                      </li>
                      <li>
                        <div class="iconL">
                          <!-- <Icon type="md-subway" /> -->
                          <img src="../../assets/images/semAd/icon-road.jpg" />
                        </div>
                        <div class="msgR">
                          <!-- <p>地铁</p> -->
                          <div>公路：中环高架金科路下闸道100米</div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">业主点评</div>
        <div class="catg-cont">
          <div class="catg6">
            <Row justify="center" align="middle" class="code-row-bg">
              <Col span="20">
                <h3>顺舟智能</h3>
                <p>
                  入驻以后企业服务非常专业，每年园区都能帮助规划申请相关配套的政策，对企业的发展起到了推动性作用
                </p>
              </Col>
              <Col span="4" class="colect"
                ><Icon type="md-heart-outline" color="#303d4b" size="38" /><span
                  >947</span
                ></Col
              >
            </Row>
            <Row justify="center" align="middle" class="code-row-bg">
              <Col span="20">
                <h3>普坤科技</h3>
                <p>
                  园区的配套非常齐全，有很多知名品牌的商家入驻，强烈推荐吃货们来尝尝。
                </p>
              </Col>
              <Col span="4" class="colect"
                ><Icon type="md-heart-outline" color="#303d4b" size="38" /><span
                  >947</span
                ></Col
              >
            </Row>
            <Row justify="center" align="middle" class="code-row-bg">
              <Col span="20">
                <h3>熠源数据</h3>
                <p>
                  服务非常效率，有问题第一时间帮助企业解决，保安尽职尽责很安全，园区配套水平也很专业，服务态度也让我满意。
                </p>
              </Col>
              <Col span="4" class="colect"
                ><Icon type="md-heart-outline" color="#303d4b" size="38" /><span
                  >947</span
                ></Col
              >
            </Row>
            <Appointment />
          </div>
        </div>
      </div>
      <div class="catg">
        <div class="catg-tit">
          云看房<small>了解更多房源，请至盛荣路88弄盛大天地·源创谷</small>
        </div>
        <div class="catg-cont">
          <div class="catg-cloudHouse">
            <Row :gutter="16" class="catg-right-box">
              <Col span="8">
                <div class="msg-box">
                  <video
                    initial-time="0.01"
                    id="video"
                    width="363"
                    height="191"
                    muted="muted"
                    controls="controls"
                    poster="../../assets/images/semAd/video-pic1.jpg"
                  >
                    <source
                      src="../../assets/images/semAd/cloud-v1.mp4"
                      type="video/mp4"
                    />
                  </video>
                  <div class="bt-box">
                    <h4>源创谷精品房源</h4>
                  </div>
                </div>
              </Col>
              <Col span="8">
                <div class="msg-box">
                  <img src="../../assets/images/semAd/video-pic2.jpg" />
                  <div class="bt-box">
                    <h4>源创谷热推房源</h4>
                  </div>
                </div>
              </Col>
              <Col span="8">
                <div class="msg-box">
                  <img src="../../assets/images/semAd/video-pic3.jpg" />
                  <div class="bt-box">
                    <h4>源创谷热推房源</h4>
                  </div>
                </div>
              </Col>
              <Col span="8">
                <div class="msg-box">
                  <img src="../../assets/images/semAd/video-pic4.jpg" />
                  <div class="bt-box">
                    <h4>源创谷热推房源</h4>
                  </div>
                </div>
              </Col>
              <Col span="8">
                <div class="msg-box">
                  <img src="../../assets/images/semAd/video-pic5.jpg" />
                  <div class="bt-box">
                    <h4>源创谷热推房源</h4>
                  </div>
                </div>
              </Col>
              <Col span="8">
                <div class="msg-box">
                  <img src="../../assets/images/semAd/video-pic6.jpg" />
                  <div class="bt-box">
                    <h4>源创谷热推房源</h4>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="serve-area">
        <img src="../../assets/images/semAd/serve-pic.jpg" />
      </div>
      <div class="shanda-bdweb-footer">
        <div class="footer-top">
          <div class="catg">
            <h3 class="footer-tit">我们期待与您合作</h3>
            <p class="footer-dec">
              从公司总部到创新空间，携手打造灵活的房地产解决方案，助力客户快速实现业务目标。
            </p>
            <div class="footer-contact">
              <Row>
                <Col span="11">
                  <div class="contact-l">
                    <img
                      style="width: 32px; height: 30px"
                      src="../../assets/images/semAd/tel-ico.png"
                    />
                    <b>021-38586888</b>
                    <!-- <span>18521094411</span> -->
                  </div>
                </Col>
                <Col span="13">
                  <div class="contact-r">
                    <img
                      style="height: 32px; width: 24px"
                      src="../../assets/images/semAd/map-ico.png"
                    />
                    中国（上海）自由贸易试验区盛荣路88弄
                  </div>
                </Col>
              </Row>
            </div>
            <div class="map-b">
              <img src="../../assets/images/semAd/map-b.png" />
            </div>
          </div>
        </div>
        <div class="footer-botm"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import ProjectCont from "@/components/ProjectCont.vue";
// import AppointmentR from "@/components/AppointmentR.vue";
// import swiperBanner from "@/components/swiperBanner.vue";
//import MapContainer from "@/components/MapContainer.vue";
import Appointment from "@/components/AppointmentSEM.vue";
export default {
  name: "index",
  components: {
    // AppointmentR: AppointmentR,
    // swiperBanner: swiperBanner,
    // ProjectCont: ProjectCont,
    //MapContainer,
    Appointment,
  },
  data() {
    return {
      modal: false,
      appointBtnTxt: "提交预约",
      projectTit: "盛大天地·源创谷",
      subHeading: "张江科学城内的大型科创园区",
      projectDec:
        "项目总建筑面积约15万平米，园区不仅具备完善的商业、商务、文化娱乐设施和青年社区配套，并拥享创新服务平台和盛大全方位优质资源的投入，形成了完善的助推企业发展的全生命周期生态系统。目前，园区内已汇聚了大量互联网、软件开发、芯片研发、智能系统、大数据等行业的优质企业，并入驻一批创新型初创、快速发展企业。未来将始终秉承创新理念，致力于发展成为以互联网、信息科技、文化创意等创新型产业为主，企业发展与人文建设并重的“创新生态之城。",
      appointMsg: "填写您的信息，获取个更多房屋租赁信息。",
      appointTit: "预约参观",
      roomId: 0,
      room: {},
      projectId: 0,
      project: {},
      contentList: [],
      imageList: [],
      name: "",
      mobile: "",
    };
  },
  methods: {
    ok() {
      if (this.name == "" || this.name == null || this.name == " ") {
        alert("请填写姓名");
        return false;
      }
      if (this.mobile == "" || this.mobile == null || this.mobile == " ") {
        alert("请填写手机号");
        return false;
      }
      let data = {
        recordType: 0,
        websiteSource: 1,
        name: this.name,
        mobile: this.mobile,
      };
      console.log(data);
      this.saving = true;
      this.$http
        .post("/api/services/app/CommonWeb/SaveWebsiteRecord", data)
        .then((res) => {
          if (res.data.success) {
            console.log(res.data);
          }
          this.name = "";
          this.mobile = "";
          this.verifyCode = "";
          this.demand = "";
          this.$Message.info("咨询成功");
        })
        .catch((error) => {
          if (error.response.data) {
            this.$Message.error(error.response.data.error.message);
          }
        })
        .finally(() => {
          this.modal = false;
        });
    },
    cancel() {
      this.$Message.info("取消咨询");
    },
    hanldeMapLoaded({ map, AMap }) {
      console.log(map);
      this.AMap = AMap;
      this.getProject().then(() => {
        var center = new AMap.LngLat(
          this.project.longitude,
          this.project.latitude,
          true
        );
        let marker = new AMap.Marker({
          position: center,
          offset: [0, -10],
        });
        map.add(marker);
        map.setZoomAndCenter(14, center, true, 400);
      });
    },
    getProject() {
      this.loading = true;
      return this.$http
        .get("/api/services/app/CommonWeb/GetProjectById?id=1")
        .then((res) => {
          this.project = res.data.result;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getRoom(roomId) {
      this.loading = true;
      this.$http
        .get("api/services/app/CommonWeb/GetRoomInfo?id=" + roomId)
        .then((res) => {
          this.room = res.data.result;
          this.room.imageUrl.forEach((item) => {
            this.imageList.push(item.url);
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getColumnByName() {
      this.loading = true;
      this.$http
        .get(
          "api/services/app/CommonWeb/GetColumnByName?businessType=1&name=服务设施&businessId=" +
            this.projectId
        )
        .then((res) => {
          this.contentList = res.data.result.columnContents;
          console.log(this.contentList);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
   computed:{
    //地图url
    getDiTuUrl(){
      return "http://api.tianditu.gov.cn/staticimage?center=121.6050,31.1719&width=350&height=350&zoom=13&layers=vec_c,cva_c&markers="+this.project.longitude+","+this.project.latitude+"&tk=8fbffc7a4eb9a0e195aa60425ca38861"
    }
  },
  mounted() {
    // this.roomId = parseInt(this.$route.query.roomId);
    // this.projectId = parseInt(this.$route.query.projectId);
    // if (this.roomId != 0) {
    //   this.getRoom(this.roomId);
    // }
    // if (this.projectId != 0) {
    //   this.getColumnByName();
    // }
  },
};
</script>

<style scoped lang="less">
.shanda-bdweb-bg {
  background: #ffffff;
}
.shanda-bdweb {
  height: auto;
  background: #ffffff;

  font-size: 13px;
  color: #333;
  img {
    width: 100%;
    vertical-align: top;
  }

  .catg {
    margin: 0 auto;
    width: 1120px;
    .link-pic {
      width: 150px;
      position: fixed;
      right: 10px;
      top: 300px;
      z-index: 100;
    }
    .bdweb-logo {
      width: 144px;
      height: 26px;
      padding-left: 20px;
    }
    .top-nav {
      color: #676767 !important;
      .active {
        color: #000;
        font-weight: bold;
        background: transparent;
        position: relative;
      }
      .active::after {
        content: "";
        display: block;
        position: absolute;
        width: 30px;
        height: 4px;
        bottom: 3px;
        left: 50%;
        margin-left: -15px;
        background: #c6b01e;
        border-radius: 2px;
      }
      .ivu-btn-text:focus {
        box-shadow: none;
      }
      .ivu-btn-text:hover {
        color: #000;
        background-color: transparent;
        border-color: transparent;
      }
    }
    .zs-line {
      text-align: center;
      .zs-line-box {
        background: #cfa972;
        color: #fff;
        font-size: 18px;
        line-height: 1;
        padding: 5px 10px;
        border-radius: 0 0 10px 10px;
        margin-bottom: 10px;
        .line {
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
    .banner-area {
      width: 100%;

      img {
        width: 100%;
        height: auto;
      }
    }
    .shanda-part6 {
      margin-top: -30px;
      .part6-cont {
        .part6-list {
          position: relative;
          .bg-img {
            width: 100%;
            vertical-align: top;
          }
          .list-cont {
            position: absolute;
            z-index: 10;
            top: 25px;
            left: 0;
            width: 100%;
            text-align: center;
            font-size: 13px;
            color: #333;
            img {
              width: 35%;
            }
            h2 {
              font-size: 18px;
              font-weight: normal;
              padding-top: 10px;
            }
            .dec {
              padding-top: 15px;
            }
          }
        }
      }
    }
    .mid-ad {
      margin-top: 15px;
    }
    .catg-tit {
      font-size: 28px;
      margin-top: 40px;
      small {
        font-size: 14px;
        color: #888;
        padding-left: 10px;
      }
    }
    .catg-cont {
      margin-top: 20px;
      .catg1-top {
        .picB {
          padding-left: 70px;
        }
        .top-cont {
          padding-left: 10px;
          h3 {
            font-size: 20px;
          }
          p {
            padding-top: 5px;
            span {
              font-size: 12px;
              margin-right: 30px;
            }
          }
        }
      }
      .catg1-botm {
        margin-top: 20px;
        .botm-cont {
          padding-top: 30px;
          padding-left: 40px;
          font-weight: bold;
          .ivu-row {
            margin-top: 10px;
            .ico {
              margin-right: 10px;
            }
          }
        }
      }
      .catg2 {
        .catg2-left {
          .left-pic {
          }
          .left-msg {
            padding: 15px;
            background-color: #eeeeee;
            h2 {
              margin-bottom: 10px;
              color: #f17627;
              font-size: 20px;
            }
            .msg-box {
              font-size: 16px;
              border: 1px solid #e5e5e5;
              text-align: center;
              padding: 15px 0;

              img {
                width: 40%;
              }
              p {
                font-size: 12px;
                padding: 10px 0;
              }
            }
            .left-botm {
              padding: 10px 0;
              text-align: right;
              margin-top: 5px;
              span {
                padding: 0 10px;
                display: inline-block;
                background-color: #303d4a;
                color: #fff;
                font-size: 16px;
              }
            }
          }
        }
        .catg2-right {
          width: 100%;
          overflow-x: scroll;
          overflow-y: hidden;
          .catg-right-box {
            width: 150%;
            overflow-x: scroll;
            margin: -10px 0;

            .ivu-col {
              margin: 10px 0;
            }
            .msg-box {
              font-size: 16px;
              img {
                height: 191px;
              }
              .bt-box {
                background-color: #eeeeee;
                padding: 15px;
                box-sizing: border-box;
                h4 {
                  color: #f17627;
                  font-size: 20px;
                }
                p {
                  font-size: 12px;
                  padding-top: 10px;
                  color: #888;
                  height: 60px;
                  overflow: hidden;
                  box-sizing: border-box;
                }
              }
            }
          }
        }
      }
      .catg3 {
        .catg3-box {
          position: relative;
          .tit {
            font-size: 20px;
            color: #fff;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.8);
            padding: 5px 20px;
          }
        }
      }
      .catg4 {
        .catg4-box {
          text-align: center;
          padding: 50px 0 60px 0;
          border: 1px solid #e5e5e5;
          margin-bottom: 20px;
          img {
            width: 30%;
          }
          h3 {
            font-size: 24px;
            color: #333;
            padding: 15px 0 10px 0;
          }
          .txt-s {
            color: #888;
            font-size: 12px;
            height: 30px;
          }
        }
        .catg4-zx {
          .zx-box {
            text-align: center;
            background: #f7f7f7;
            .zx-box-L {
              background: #eeeeee;
              color: #000;
              font-size: 14px;
              padding: 30px 0;
              span {
                color: #f60;
              }
            }
            .zx-box-R {
              color: #666;
              font-size: 13px;
              .zx-box-RTxt {
                .rtxt {
                  padding: 2px 10px;
                  box-sizing: border-box;
                  span {
                    display: inline-block;
                    margin-left: 30px;
                    margin-right: 10px;
                  }
                }
              }
              .zx-btn {
                button {
                  background: #cfa972;
                  color: #fff;
                  border-radius: 0;
                  font-size: 18px;
                }
              }
            }
          }
        }
        .catg4-location {
          margin-top: 20px;
          .loaction-txt {
            background: #2d2d2d;
            color: #fff;
            padding: 10px 50px;
            width: 100%;
            font-size: 22px;
            line-height: 1.8;
          }
        }
      }
      .catg5 {
        .intro-cont-box {
          .cont-part1 {
            display: flex;
            justify-content: flex-start;

            .ivu-col-span-6 {
              display: flex;
              flex-flow: row;
              align-items: center;

              .img-l {
                margin-right: 15px;

                img {
                  display: block;
                }
              }

              .txt-r {
                font-size: 16px;

                p {
                  font-size: 12px;
                  color: #999;
                }
              }
            }
          }

          .tit-dec {
            margin-bottom: -10px;
            font-size: 14px;

            .ivu-col-span-6 {
              margin-bottom: 20px;

              span {
                width: 70px;
                color: #666;
              }
            }
          }

          .code-row-bg {
            text-align: center;
            margin: 0 -10px;
            justify-content: flex-start;
            .ivu-col-span-6 {
              margin-bottom: 20px;

              .equ {
                margin: 0 10px;
                background-color: #fff;
                border: 1px solid #efefef;
                border-radius: 5px;

                img {
                  width: 100%;
                  height: 95px;
                  border-radius: 5px;
                  line-height: 0;
                  display: block;
                }

                p {
                  font-size: 14px;
                  line-height: 32px;
                }
              }

              .equ:hover {
                box-shadow: 0px 0px 2px 0px rgba(70, 139, 254, 0.7);
              }
            }
          }

          .office-addr {
            .office-map {
              border: 1px solid rgba(0, 0, 0, 0.3);
              margin-right: 30px;

              img {
                width: 100%;
                height: 100%;
                line-height: 0;
                display: block;
              }
            }

            .addr-msg {
              padding-left: 30px;
              ul {
                li {
                  display: flex;
                  align-items: center;
                  margin: 30px 0;

                  .iconL {
                    background-color: #66cff2;
                    height: 30px;
                    line-height: 30px;
                    width: 30px;
                    text-align: center;
                    color: #fff;
                    font-size: 18px;
                    border-radius: 5px;
                    flex: none;
                  }

                  .msgR {
                    margin-left: 10px;
                    font-size: 14px;

                    p {
                      color: #3376fe;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .catg6 {
        .code-row-bg {
          background: #eee;
          padding: 20px 30px;
          border-bottom: 1px dashed #ccc;
          h3 {
            color: #f17627;
            font-size: 18px;
          }
          p {
            padding-top: 10px;
            color: #888;
          }
          span {
            font-size: 16px;
            color: #888;
            vertical-align: 5px;
            padding-left: 6px;
          }
          .colect {
            text-align: right;
          }
        }
        .appointment {
          position: relative;
        }
      }
      .catg-cloudHouse {
        .catg-right-box {
          .ivu-col {
            margin: 10px 0;
          }
          .msg-box {
            font-size: 16px;
            img {
              height: 191px;
              width: 363px;
            }
            .bt-box {
              background-color: #eeeeee;
              padding: 15px;
              box-sizing: border-box;
              margin: 0 10px;
              h4 {
                color: #f17627;
                font-size: 20px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
  .serve-area {
    margin: 60px auto 40px auto;
    width: 1340px;
  }
  .shanda-bdweb-footer {
    .footer-top {
      padding: 60px;
      background: #3e4347;
      .footer-tit {
        color: #fff;
        font-size: 30px;
      }
      .footer-dec {
        color: #fff;
        font-weight: bold;
      }
      .footer-contact {
        background: #fff;
        padding: 5px;
        margin-top: 20px;
        border-radius: 30px;
        color: #616d7e;
        img {
          vertical-align: -4px;
          margin-right: 10px;
        }
        .contact-l {
          background: #e2ecf1;
          border-radius: 30px;
          padding: 5px 30px;
          font-size: 28px;
          margin-right: 20px;
          span {
            font-size: 24px;
            padding-left: 10px;
          }
        }
        .contact-r {
          font-size: 26px;
          padding: 5px 30px;
        }
      }
      .map-b {
        width: 100%;
        margin-top: 30px;
      }
    }
    .footer-botm {
      background: #393d40;
      height: 60px;
    }
  }
}
</style>
